module.exports = __webpack_public_path__ + "img/clothing-express.66c845a7.png";